import {CtModelRouteData} from "@ctsolution/ct-framework";

export const TaskLeadRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("task_lead");